import React from 'react';
import styles from './Sports.module.css';

const Sports = ({ lang }) => {
  const data = {
    EN: {
      title: "Sports World",
      btn: "Load More News",
      featured: "Cricket World Cup: Dramatic Final Underway",
      list: ["Tennis star wins Grand Slam", "Football transfers heating up", "Olympic preparations at peak", "New swimming world record", "Basketball league updates", "Golf championship news", "Athletics meeting report", "Badminton tournament finals"]
    },
    UR: {
      title: "کھیلوں کی دنیا",
      btn: "مزید خبریں",
      featured: "کرکٹ ورلڈ کپ: ڈرامائی فائنل جاری",
      list: ["ٹینس اسٹار نے گرینڈ سلیم جیت لیا", "فٹ بال ٹرانسفرز میں تیزی", "اولمپک کی تیاریاں عروج پر", "تیراکی میں نیا عالمی ریکارڈ", "باسکٹ بال لیگ کی تازہ ترین خبریں", "گولف چیمپئن شپ کی خبریں", "ایتھلیٹکس میٹنگ رپورٹ", "بیڈمنٹن ٹورنامنٹ کے فائنلز"]
    }
  }[lang];

  return (
    <section className={styles.sportsSection}>
      <h2 className={styles.sectionHeader}>{data.title}</h2>
      
      {/* Featured News */}
      <div className={styles.featuredNews}>
        <img src="https://picsum.photos/800/500?1" alt="Featured" />
        <h2>{data.featured}</h2>
      </div>

      {/* Grid of News */}
      <div className={styles.newsGrid}>
        {data.list.map((item, i) => (
          <div key={i} className={styles.newsItem}>
            <img src={`https://picsum.photos/200/150?${i}`} alt="sports" />
            <h4>{item}</h4>
          </div>
        ))}
      </div>

      {/* More Button */}
      <div className={styles.moreBtnWrapper}>
        <button className={styles.moreBtn}>{data.btn}</button>
      </div>
    </section>
  );
};

export default Sports;